import { createRoot } from "react-dom/client";
import { createBrowserRouter, Outlet, RouterProvider, ScrollRestoration, useRouteError } from "react-router-dom";
import RootLayout from "./app/layout";
import Template from "./app/template";
import { NotFound } from "./routing/navigation";
import { createVoidpulseRoutes } from "./routing/routes";
import { isDesignChangeOn } from "./app/design-review/useDesignChange";
import { StatusPage, statusActionCn } from "./app/ui/StatusPage";

function RouteError() {
  const error = useRouteError();
  console.error("Voidpulse route failed", error);
  if (isDesignChangeOn("not-found")) {
    return (
      <StatusPage
        code="Something went wrong"
        title="This page failed to load"
        message="An unexpected error stopped this page from rendering. Reloading usually fixes it."
        action={
          <button type="button" className={statusActionCn} onClick={() => window.location.reload()}>
            Reload page
          </button>
        }
      />
    );
  }
  return (
    <main className="p-6">
      <h1>Unable to load this page</h1>
      <button type="button" onClick={() => window.location.reload()}>
        Reload
      </button>
    </main>
  );
}

const pages = import.meta.glob("./app/**/page.tsx");
const layouts = import.meta.glob("./app/**/layout.tsx");
const router = createBrowserRouter([
  {
    element: (
      <RootLayout>
        <Template>
          <Outlet />
          <ScrollRestoration />
        </Template>
      </RootLayout>
    ),
    errorElement: <RouteError />,
    children: [
      ...createVoidpulseRoutes(
        pages as Parameters<typeof createVoidpulseRoutes>[0],
        layouts as Parameters<typeof createVoidpulseRoutes>[1],
      ),
      { path: "*", element: <NotFound /> },
    ],
  },
]);

createRoot(document.getElementById("root")!).render(<RouterProvider router={router} />);
